import React, { useEffect, useRef, useState } from "react";
import CurrencyConverter from "@heartinz/currency_subunit_converter";
import DateConverter from "@heartinz/date_and_time_processor";
import { useAuth } from "../../../../context/AuthProvider";
import { useContextApi } from "../../../../context/ContextApi";
import uRLs from "../../../../utils/baseUtils";
import { handleUnitNameSelect } from "../../../../utils/unitUtils";
import { AddIcon, XIcon } from "../../../../constants/Icons";

const MatchStock = ({ data, onAdd, addToStockCart, onClose }) => {
  const [selectedIndex, setSelectedIndex] = useState(0);
  const [inputValues, setInputValues] = useState({});
  const [errors, setErrors] = useState({});
  const inputRefs = useRef([]);
  const productMdateRef = useRef(null);
  const [unitData, setUnitData] = useState();
  const [selectedUnit, setSelectedUnit] = useState();
  const handleUpdateRef = useRef(null);
  const { isUser, settings } = useAuth();
  const { useEscapeKey } = useContextApi();
  useEscapeKey(onClose);

  const handleUnitName = (unitData) => {
    handleUnitNameSelect(unitData,settings);
  };
  // Handle radio selection
  const handleRadioChange = (newIndex) => {
    setInputValues((prevValues) => ({
      ...prevValues,
      [selectedIndex]: "",
    }));
    setErrors((prevErrors) => {
      const updatedErrors = { ...prevErrors };
      delete updatedErrors[selectedIndex];
      return updatedErrors;
    });
    setSelectedIndex(newIndex);
  };

  // Handle quantity input
  const handleInputChange = (value, index) => {
    let regex;

    // no unit -> only integer
    if (!unitData) {
      regex = /^\d*$/;
    }

    // primary unit -> 3 decimal
    else if (selectedUnit === unitData?.primaryUnitCode) {
      regex = /^\d*\.?\d{0,3}$/;
    }

    // secondary unit -> 1 decimal
    else if (selectedUnit === unitData?.secondaryUnitCode) {
      regex = /^\d*\.?\d{0,1}$/;
    }

    // validation fail
    if (!regex.test(value)) return;

    setInputValues((prevValues) => ({
      ...prevValues,
      [index]: value,
    }));

    setErrors((prevErrors) => {
      const updatedErrors = { ...prevErrors };
      delete updatedErrors[index];
      return updatedErrors;
    });
  };

  const handleUnitConversion = (unitName, type) => {
    if (unitName === selectedUnit) return;

    setSelectedUnit(unitName);
    if (uRLs.UNIT === "true") {
      if (type === "p") {
        setInputValues(0);
      } else if (type === "s") {
        setInputValues(0);
      }
    }
  };

  // Add selected stock to cart
  const handleAdd = () => {
    const selectedData = data[selectedIndex];
    const quantity = inputValues[selectedIndex];
    if (!quantity || isNaN(parseInt(quantity)) || quantity <= 0.0) {
      setErrors((prevErrors) => ({
        ...prevErrors,
        [selectedIndex]: "Enter a Quantity.",
      }));
      inputRefs.current[selectedIndex]?.focus();
      return;
    }
    const stockData = {
      _id: selectedData.productid,
      stockLinkId: selectedData.stockLinkId,
      stocklid: selectedData._id,
      stockid: selectedData.stockid,
      productid: selectedData.productid,
      // title: selectedData.normalizedTitle,
      mrp: selectedData.mrp,
      saleprice: selectedData.saleprice,
      taxpercentage: selectedData.taxpercentage,
      baseprice: selectedData.baseprice,
      discount: selectedData.discount,
      taxamount: selectedData.taxamount,
      isLock: selectedData.isLock,
      landingcost: selectedData.landingcost,
      quantity: Number(quantity),
      status: "RECEIVED",
      code: selectedData.code,
      title: selectedData.title,
      isStock: true,
      unitConfig: selectedData.unitConfig,
      selectedUnitCode: selectedUnit,
      totalStockLeft: selectedData.totalStockLeft,
    };
    // addToStockCart(stockData);
    onAdd(stockData);
  };

  // Handle keyboard navigation
  const handleKeyDown = (e) => {
    if (e.key === "ArrowDown") {
      e.preventDefault();
      const newIndex = (selectedIndex + 1) % data.length;
      handleRadioChange(newIndex);
    } else if (e.key === "ArrowUp") {
      e.preventDefault();
      const newIndex = (selectedIndex - 1 + data.length) % data.length;
      handleRadioChange(newIndex);
    }
  };

  const handleEnterKey = (e, fieldName, nextRef = null, isLast = false) => {
    if (e.key === "Enter") {
      e.preventDefault();

      const trimmedData = String(inputValues || "").trim();

      if (!trimmedData) {
        setErrors((prev) => ({
          ...prev,
          [fieldName]: "Enter a valid quantity greater than 0.",
        }));
        return;
      }

      setErrors((prev) => ({
        ...prev,
        [fieldName]: "",
      }));

      if (isLast) {
        handleAdd();
      } else if (
        nextRef?.current &&
        typeof nextRef.current.focus === "function"
      ) {
        nextRef.current.focus();
      }
    }
  };

  useEffect(() => {
    if (data?.length > 0) {
      const currentItem = data[selectedIndex] || data[0];

      if (currentItem?.unitConfig) {
        const name = handleUnitName(currentItem.unitConfig);

        setUnitData({
          ...currentItem.unitConfig,
          primaryUnitName: name?.primaryUnitName,
          secondaryUnitName: name?.secondaryUnitName,
        });
      } else {
        setUnitData(null);
      }
    }
  }, [data, selectedIndex]);

  useEffect(() => {
    const currentItem = data?.[selectedIndex] || data?.[0];

    setSelectedUnit(currentItem?.unitConfig?.primaryUnitCode || "");
  }, [data, selectedIndex]);

  useEffect(() => {
    document.addEventListener("keydown", handleKeyDown);
    return () => {
      document.removeEventListener("keydown", handleKeyDown);
    };
  }, [selectedIndex]);

  // Focus input on selected index change
  useEffect(() => {
    if (inputRefs.current[selectedIndex]) {
      inputRefs.current[selectedIndex].focus();
    }
  }, [selectedIndex]);

  console.log("MatchStock data:", data);

  return (
    <div>
      <div className="modal-backdrop show"></div>
      <div
        className="modal show"
        id="CustomerModal"
        tabIndex="0"
        aria-modal="true"
        role="dialog"
        style={{ display: "block" }}
      >
        <div className="modal-dialog modal-dialog-scrollable modal-dialog-centered modal-xl">
          <div className="modal-content">
            <div className="modal-header">
              <h6 className="modal-title">Stock Availability</h6>
              <button
                type="button"
                onClick={onClose}
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              ></button>
            </div>
            <div className="modal-body">
              <div className="d-block px-2">
                <h6 className="text-center py-2">
                  <span className="badge rounded-pill bg-label-navy">
                    {data[0]?.code}{" "}
                  </span>
                  &nbsp;- {data[0]?.normalizedTitle || data[0]?.title}
                </h6>
              </div>
              <div className="table-responsive" style={{ overflow: "visible" }}>
                <table className="table align-middle mb-0">
                  <thead className="table-light">
                    <tr>
                      <th></th>
                      <th className="text-center">MRP</th>
                      <th className="text-center">Sale Price</th>
                      <th className="text-center">Tax(%)</th>
                      <th className="text-center">Date</th>
                      {/* <th className="text-center w-10">Stock Left</th> */}
                      <th className="text-center w-15">Qty</th>
                    </tr>
                  </thead>
                  <tbody>
                    {data.map((item, index) => (
                      <tr
                        key={index}
                        className={
                          selectedIndex === index ? "selected-row" : ""
                        }
                        onClick={() => handleRadioChange(index)}
                      >
                        <td>
                          <input
                            className="input"
                            type="radio"
                            name="productSelection"
                            value={item._id}
                            checked={selectedIndex === index}
                            onChange={() => handleRadioChange(index)}
                          />
                        </td>
                        <td className="text-center">
                          <span className="badge bg-label-fall rounded-pill">
                            ₹
                            {CurrencyConverter.toCurrency(
                              item?.mrp || 0,
                              "INR"
                            )}
                          </span>
                        </td>
                        <td className="text-center">
                          <span className="badge bg-label-food rounded-pill">
                            ₹
                            {CurrencyConverter.toCurrency(
                              item?.saleprice || 0,
                              "INR"
                            )}
                          </span>
                        </td>
                        <td className="text-center">
                          <span className="badge rounded-pill bg-label-peace">
                            {item.taxpercentage}%
                          </span>
                        </td>
                        <td className="text-center">
                          <small className="text-truncate d-sm-block badge bg-label-tea rounded-pill mb-1">
                            MFD :{" "}
                            {item?.manufacturedate
                              ? DateConverter.ISOToDisplayFormat(
                                  DateConverter.convertToTimeZone(
                                    item?.manufacturedate,
                                    isUser.timezone
                                  )
                                ).date
                              : ""}
                          </small>
                          <small className="text-truncate d-sm-block badge bg-label-red rounded-pill">
                            EXP :{" "}
                            {item?.expiredate
                              ? DateConverter.ISOToDisplayFormat(
                                  item.expiredate,
                                  isUser.timezone
                                ).date
                              : ""}
                          </small>
                        </td>
                        {/* <td className="text-center">
                          <span className="badge bg-label-space mx-1">
                            {item.stockLeft}
                          </span>
                        </td> */}
                        <td>
                          <div className="input-group">
                            <input
                              type="text"
                              className="form-control text-center"
                              ref={(el) => (inputRefs.current[index] = el)}
                              value={inputValues[index] || ""}
                              onChange={(e) =>
                                handleInputChange(e.target.value, index)
                              }
                              // maxLength={String(item.stockLeft).length}
                              onKeyDown={(e) =>
                                handleEnterKey(
                                  e,
                                  "inputValue",
                                  handleUpdateRef,
                                  true
                                )
                              }
                            />
                            {uRLs.UNIT === "true" && item?.unitConfig && (
                              <div
                                className="d-flex text-start "
                                style={{ zIndex: 1000 }}
                              >
                                <button
                                  className="btn btn-unit shadow-none   rounded-start-0  dropdown-toggle-split"
                                  // id="printreceiptbtn"
                                  // data-bs-toggle="dropdown"
                                >
                                  {selectedUnit}
                                </button>
                                {/* <button
                          type="button" 
                          className="btn btn-unit shadow-none  dropdown-toggle dropdown-toggle-split rounded-start-0 border-start-0"
                          data-bs-toggle="dropdown"
                          aria-expanded="false"
                          
                        />
                        <ul className="dropdown-menu dropdown-menu-end">
                         
                         <li>
                           <button
                             className={`dropdown-item ${
                               selectedUnit === unitData?.primaryUnitCode ? "active" : ""
                             }`}
                             onClick={() => {
                              inputRefs.current[index]?.focus();
                               handleUnitConversion(unitData?.primaryUnitCode,'p')
                             }}
                           >
                             {unitData?.primaryUnitName} ({unitData?.primaryUnitCode})
                           </button>
                         </li>
                         {unitData?.secondaryUnitName && (
                         <li>
                           <button
                             className={`dropdown-item ${
                               selectedUnit === unitData?.secondaryUnitCode ? "active" : ""
                             }`}
                             onClick={() => {
                              inputRefs.current[index]?.focus();
                               handleUnitConversion(unitData?.secondaryUnitCode,'s')
                             }}
                           >
                             {unitData?.secondaryUnitName} ({unitData?.secondaryUnitCode})
                           </button>
                         </li>
                         )}
                     </ul> */}
                              </div>
                            )}
                          </div>
                          {errors[index] && (
                            <div className="invalid-feedback text-center">
                              {errors[index]}
                            </div>
                          )}
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
            <div className="modal-footer d-block">
              <button
                onClick={onClose}
                type="button"
                data-bs-dismiss="modal"
                className="btn btn-outline-secondary text-left"
              >
                <XIcon iClass={"fs-15"}/> Cancel
              </button>
              <button
                onClick={handleAdd}
                ref={handleUpdateRef}
                type="button"
                className="btn btn-teal text-right"
              >
                <AddIcon/> Add
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MatchStock;
